module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-soda-fe-soda-bd-i18n",
  "filePath": "/src/i18n",
  "prefix": "soda-bd-i18n---",
  "getLangCodeString": "localStorage.getItem('language').replace(/\"/g, \"\")",
  "noParse": true,
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-soda-fe-soda-bd-i18n/src/i18n/all.js"
}